import { httpJsonGet, AdminPath } from '../lib/http';
export function listChannels() {
    return httpJsonGet(AdminPath.channels);
}
